import { newsletterService } from "./newsletter.service"
import { feedbackService } from "./userMessage.service";
import { validateEmail } from "../core/helpers/index";


export class TbwNewsletterFormComponent extends HTMLElement {
  private frenchId: string = "";
  private englishId: string = "";
  private currentLanguage = "english";

  private options = {
    french: {
      value: "french",
      flag: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512"><clipPath id="fr-round-mask"><circle cx="50%" cy="50%" r="50%" fill="white" /></clipPath><g clip-path="url(#fr-round-mask)"><g fill-rule="evenodd" stroke-width="1pt"><path fill="#fff" d="M0 0h512v512H0z"/><path fill="#00267f" d="M0 0h170.7v512H0z"/><path fill="#f31830" d="M341.3 0H512v512H341.3z"/></g></g></svg>`,
      alt: "Français",
    },
    english: {
      value: "english",
      flag: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512"><clipPath id="gb-round-mask"><circle cx="50%" cy="50%" r="50%" fill="white" /></clipPath><g clip-path="url(#gb-round-mask)"><path fill="#012169" d="M0 0h512v512H0z"/><path fill="#FFF" d="M512 0v64L322 256l190 187v69h-67L254 324 68 512H0v-68l186-187L0 74V0h62l192 188L440 0z"/><path fill="#C8102E" d="M184 324l11 34L42 512H0v-3l184-185zm124-12l54 8 150 147v45L308 312zM512 0L320 196l-4-44L466 0h46zM0 1l193 189-59-8L0 49V1z"/><path fill="#FFF" d="M176 0v512h160V0H176zM0 176v160h512V176H0z"/><path fill="#C8102E" d="M0 208v96h512v-96H0zM208 0v512h96V0h-96z"/></g></svg>`,
      alt: "English",
    },
  };

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeIds();
    this.render();
    this.initializeEventListeners();
  }

  private initializeIds(): void {
    const frenchId = this.getAttribute("data-french-id");
    const englishId = this.getAttribute("data-english-id");

    if (!frenchId || !englishId) {
      throw new Error("Newsletter ids not found");
    }

    this.frenchId = frenchId;
    this.englishId = englishId;
  }

  private render(): void {
    this.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }

        .newsletter-management-container {
          width: 100%;
          position: relative;
        }

        .newsletter-form_div {
          padding: var(--_spaces---space-sm) var(--_spaces---space-sm-2) var(--_spaces---space-sm) var(--_spaces---space-lg);
          background-color: #f1f0f5;
          border-radius: var(--_radius---radius-2xl);
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: var(--_spaces---space-sm);
          border: 1px solid transparent;
          box-sizing: border-box;
        }

        .text-input {
          background-color: transparent;
          border: none;
          font-size: 18px !important;
          width: 100%;
        }

        .text-input:enabled {
          border: none;
          outline: none;
        }

        .text-input::placeholder {
          font-size: 18px;
          color: #161032;
        }

        .newsletter-submit-button {
          background-color: #3442eb;
          color: white;
          border: none;
          padding: var(--_spaces---space-sm-2) var(--_spaces---space-lg);
          font-size: 18px;
          font-weight: 500;
          border-radius: var(--_radius---radius-2xl);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .select-dropdown-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: var(--_spaces---space-sm);
        }

        .custom-select {
          position: relative;
          display: inline-block;
        }

        .select-button {
          background-color: white;
          border: none;
          padding: var(--_spaces---space-sm) var(--_spaces---space-sm);
          border-radius: var(--_radius---radius-2xl);
          width: fit-content;
          display: flex;
          align-items: center;
          gap: var(--_spaces---space-sm);
          cursor: pointer;
          font-size: 16px;
          color: #161032;
          height: 100%;
          min-width: 45px;
        }

        .select-button:enabled {
          outline: none;
        }

        .select-button:hover {
          background-color: #f8f8f8;
        }

        .flag-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: var(--_radius---radius-2xl);
          overflow: hidden;
        }
        
        .flag-icon svg {
          width: 100%;
          height: 100%;
        }

        .select-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background-color: white;
          overflow: hidden;
          border: 1px solid #e0e0e0;
          border-radius: var(--_radius---radius-lg);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          z-index: 9999;
          display: none;
          margin-top: 4px;
          width: 100%;
          min-width: 0;
        }

        .select-dropdown.show {
          display: block;
        }

        .select-option {
          padding: var(--_spaces---space-sm) var(--_spaces---space-sm);
          display: flex;
          align-items: center;
          cursor: pointer;
          transition: background-color 0.2s ease;
        }

        .select-option:hover {
          background-color: #f8f8f8;
        }

        .select-option:first-child {
          border-radius: var(--_radius---radius-lg) var(--_radius---radius-lg) 0 0;
        }

        .select-option:last-child {
          border-radius: 0 0 var(--_radius---radius-lg) var(--_radius---radius-lg);
        }

        .newsletter-message-container {
          width: 100%;
          position: absolute;
          bottom: -var(--_spaces---space-sm);
        }

        .newsletter_signup-success_message,
        .nl-subscription_error-message {
          display: none;
          align-items: center;
          gap: var(--_spaces---space-sm);
          padding: var(--_spaces---space-sm);
          border-radius: var(--_radius---radius-lg);
          font-size: 14px;
          font-weight: 500;
          margin-top: var(--_spaces---space-sm);
        }

        .newsletter_signup-success_message {
          background-color: var(--base-color-brand--accent-lime);
          color: #161032;
        }

        .nl-subscription_error-message {
        background-color: var(--base-color-brand--accent-coral);
          color: white;
        }

        .newsletter_signup-success_message svg,
        .nl-subscription_error-message svg {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }

        [disabled] {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid;
          border-bottom-color: transparent !important;
          border-radius: 50%;
          display: inline-block;
          animation: rotation 1s linear infinite;
          margin-left: 8px;
          vertical-align: middle;
          flex-shrink: 0;
        }

        @keyframes rotation {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      </style>

      <div class="newsletter-management-container">
        <form class="newsletter-form_div newsletter-form">
          <input
            type="email"
            class="text-input is-full-width newsletter-email"
            name="email"
            placeholder="Enter your email"
          />
          
          <div class="select-dropdown-container">
            <div class="custom-select">
              <button type="button" class="select-button" id="language-selector">
                <span class="flag-icon">${this.options.english.flag}</span>
              </button>

              <div class="select-dropdown" id="language-dropdown">
                <div class="select-option" id="dropdown-option"></div>
              </div>
              <input type="hidden" name="language" value="english" />
            </div>
          </div>

          <button
            class="newsletter-submit-button"
            type="button"
          >Subscribe</button>
        </form>
        
        <div class="newsletter-message-container">
          <div class="newsletter_signup-success_message is-text"></div>
          <div class="nl-subscription_error-message is-text"></div>
        </div>
      </div>
    `;
  }

  private initializeEventListeners(): void {
    this.initializeDropdown();
    this.initializeSubmitButton();
    this.initializeDropdownState();
  }

  private initializeDropdown(): void {
    const languageSelector = this.querySelector(".select-button");
    const languageDropdown = this.querySelector(".select-dropdown");
    const languageInput = this.querySelector("input[name='language']") as HTMLInputElement;

    if (!languageSelector || !languageDropdown || !languageInput) {
      console.error("Language dropdown elements not found");
      return;
    }

    // Toggle dropdown on button click
    languageSelector.addEventListener("click", (e) => {
      e.preventDefault();
      languageDropdown.classList.toggle("show");
    });

    // Handle option selection
    const optionElements = languageDropdown.querySelectorAll(".select-option");
    optionElements.forEach((optionElement) => {
      optionElement.addEventListener("click", () => {
        const value = optionElement.getAttribute("data-value");
        const flagSrc = optionElement.getAttribute("data-flag");
        const flagAlt = optionElement.getAttribute("data-alt");

        if (value && flagSrc && flagAlt) {
          languageInput.value = value;
          this.currentLanguage = value;

          // Update button flag based on selected language
          const flagIcon = languageSelector.querySelector(".flag-icon") as HTMLElement;
          if (flagIcon && flagSrc) {
            flagIcon.innerHTML = flagSrc;
          }

          // Update dropdown to show the inactive option
          this.updateDropdownForSelection(value);
          languageDropdown.classList.remove("show");
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (
        !languageSelector.contains(e.target as Node) &&
        !languageDropdown.contains(e.target as Node)
      ) {
        languageDropdown.classList.remove("show");
      }
    });
  }

  private initializeDropdownState(): void {
    // Set the initial inactive option (French) in the dropdown
    this.updateDropdownOption("french");
  }

  private updateDropdownOption(language: string): void {
    const dropdownOption = this.querySelector("#dropdown-option");
    if (!dropdownOption) return;

    const option = this.options[language as keyof typeof this.options];
    if (!option) return;

    dropdownOption.setAttribute("data-value", option.value);
    dropdownOption.setAttribute("data-flag", option.flag);
    dropdownOption.setAttribute("data-alt", option.alt);
    dropdownOption.innerHTML = `
      <span class="flag-icon">${option.flag}</span>
    `;
  }

  private updateDropdownForSelection(selectedLanguage: string): void {
    // Find the inactive language (the one not currently selected)
    const inactiveLanguage = selectedLanguage === "french" ? "english" : "french";
    this.updateDropdownOption(inactiveLanguage);
  }

  private initializeSubmitButton(): void {
    const submitButton = this.querySelector(".newsletter-submit-button");
    if (!submitButton) {
      console.error("Submit button not found");
      return;
    }

    submitButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
  }

  public setEmailInputValue(email: string): void {
    const emailSelector = this.querySelector(".newsletter-email") as HTMLInputElement;
    if (emailSelector) {
      emailSelector.value = email;
      emailSelector.disabled = true;
      emailSelector.style.cursor = "not-allowed";
    }
  }

  private async handleSubmit(): Promise<void> {
    feedbackService.hideMessages(this);
    feedbackService.setSubmitButtonLoading(true, this);

    try {
      const form: HTMLFormElement | null = this.querySelector(".newsletter-form");
      if (!form) {
        throw new Error("Form not found");
      }

      const emailSelector = form.querySelector(".newsletter-email") as HTMLInputElement;
      const languageSelector = form.querySelector("input[name='language']") as HTMLInputElement;

      if (validateEmail(emailSelector.value) === false) {
        const errorMessage = "Please enter a valid email address";
        throw new Error(errorMessage);
      }

      const email = emailSelector.value;
      const language = languageSelector.value;

      const id = language === "french" ? this.frenchId : this.englishId;
      if (!id) {
        const errorMessage = "Please select a language";
        throw new Error(errorMessage);
      }

      const response = await newsletterService.subscribe(email, id);

      const successMessage = "Success ! You are subscribed to the newsletter";
      feedbackService.showSuccessMessage(successMessage, this);
      return response;
    } catch (error: any) {
      let errorMessage = error.message;
      feedbackService.showErrorMessage(errorMessage, this);
    } finally {
      feedbackService.setSubmitButtonLoading(false, this);
    }
  }
}
